import {combineReducers} from '@reduxjs/toolkit';
import {manage_tenants} from './Tenants';
import {licenses, providers} from "../modules/licenses/reducers";

export const manageContext = combineReducers({
  tenants: manage_tenants,
  licenses: licenses,
  providers: providers
});
